import { CLOSE_POPUP, SET_POPUP } from "./types";

const initialState = {
  popup: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_POPUP:
      return {
        ...state,
        popup: action.payload,
      };

    case CLOSE_POPUP:
      return {
        ...state,
        popup: { ...state.popup, closePopup: true, isVisible: false },
      };

    default:
      return state;
  }
}
export default reducer;
